import { getUserInfo } from 'ui-addon-upgrades/_core/common/api/getUserInfo';
export const getCanCheckoutRecurringSkusAsIncrease = () => {
  return getUserInfo().then(({
    gates
  }) => {
    return gates.includes('CBX:RecurringQuantifiableSkuQuantityIncrease');
  });
};